import { useState, useEffect } from "react";

export const CART_TABLE_KEYBOARD_HIGHLIGHT_BG = "#ebf5ff";

export const isCartKeyboardNavigationBlocked = (el) => {
  if (!el) return false;
  const t = el.tagName ? el.tagName.toLowerCase() : "";
  if (t === "input" || t === "textarea" || t === "select") return true;
  if (el.isContentEditable) return true;
  return false;
};

export const isOfferProductsDialogOpen = () => {
  if (typeof document === "undefined") return false;
  return Boolean(document.querySelector('[data-offer-products-dialog="true"]'));
};

export const isInsideModalDialog = (el) => {
  if (!el || !(el instanceof Element)) return false;
  if (el.closest('[data-offer-products-dialog="true"]')) return true;
  return Boolean(el.closest('[role="dialog"]'));
};

export const getCartTableKeyboardHighlightSx = () => ({
  bgcolor: CART_TABLE_KEYBOARD_HIGHLIGHT_BG,
  "&:hover": { bgcolor: CART_TABLE_KEYBOARD_HIGHLIGHT_BG },
});

export const getRhpCartTableRowSelectionSx = () => ({
  boxShadow: "inset 0 0 0 1px #000",
  borderRadius: "4px",
});

export const useCartTableKeyboardNavigation = (rowCount) => {
  const [keyboardRowIndex, setKeyboardRowIndex] = useState(null);

  useEffect(() => {
    if (rowCount === 0) {
      setKeyboardRowIndex(null);
      return;
    }
    if (keyboardRowIndex !== null && keyboardRowIndex > rowCount - 1) {
      setKeyboardRowIndex(rowCount - 1);
    }
  }, [rowCount, keyboardRowIndex]);

  useEffect(() => {
    if (rowCount === 0) return;
    const onKeyDown = (e) => {
      if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
      if (isOfferProductsDialogOpen()) return;
      const active = document.activeElement;
      if (active instanceof Element && isInsideModalDialog(active)) {
        return;
      }
      if (e.target instanceof Element && isInsideModalDialog(e.target)) {
        return;
      }
      if (isCartKeyboardNavigationBlocked(active)) return;
      e.preventDefault();
      if (e.key === "ArrowDown") {
        setKeyboardRowIndex((prev) => {
          if (prev === null) return 0;
          return Math.min(prev + 1, rowCount - 1);
        });
      } else {
        setKeyboardRowIndex((prev) => {
          if (prev === null) return rowCount - 1;
          return Math.max(prev - 1, 0);
        });
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [rowCount]);

  return [keyboardRowIndex, setKeyboardRowIndex];
};
